import useAudioOutputSync from './useAudioOutputSync';

const useWaitingRoomAudioOutputSync = ({
  meetingManager,
  activeSpeakerDeviceId,
  setActiveSpeakerDeviceId,
  onAudioOutputSelected,
  setSpeakerMenuDevices,
  initialAudioOutputDeviceId,
}) => {
  const { applyOutputDevice } = useAudioOutputSync({
    meetingManager,
    activeDeviceId: activeSpeakerDeviceId,
    setActiveDeviceId: setActiveSpeakerDeviceId,
    onDeviceSelected: onAudioOutputSelected,
    setMenuDevices: setSpeakerMenuDevices,
    initialDeviceId: initialAudioOutputDeviceId || '',
    autoSelectNewDevices: true,
  });

  return { applySpeakerDevice: applyOutputDevice };
};

export default useWaitingRoomAudioOutputSync;